if (!customElements.get('coweet-navigation-articles')) {
  customElements.define('coweet-navigation-articles', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const slides = [...this.querySelectorAll('[data-slide]')];
      const controls = this.querySelector('[data-controls]');
      if (!controls || slides.length < 2) return;
      let index = 0;
      controls.hidden = false;
      controls.addEventListener('click', event => {
        const button = event.target.closest('button[data-direction]');
        if (!button) return;
        // The theme drawer treats other button clicks as submenu back actions.
        event.preventDefault();
        event.stopPropagation();
        slides[index].hidden = true;
        index = (index + Number(button.dataset.direction) + slides.length) % slides.length;
        slides[index].hidden = false;
        this.querySelector('[data-position]').textContent = `${index + 1} / ${slides.length}`;
      }, true);
    }
  });
}
